import { alpha } from '@mui/material/styles';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  leftIcon: {
    marginRight: theme.spacing(2),
  },
  noPadding: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  imageIcon: {
    position: 'absolute',
    bottom: 2,
    right: 2,
    color: theme.colors.white,
  },
  topList: {
    borderColor: theme.palette.action.disabled,
    borderBottomWidth: 2,
  },
  topBar: {
    backgroundColor: theme.palette.action.disabledBackground,
    margin: '5px 10px 0 10px',
    height: 2,
  },
  button: {
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },
  expandButton: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    '& span': {
      display: 'flex',
      alignItems: 'center',
      maxHeight: '21px',
      overflow: 'visible',
    },
  },
  subText: {
    display: 'block',
    fontSize: 12,
  },
  textRow: {
    marginRight: 65,
  },
  flexrow: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
  },
  leftIconWrap: {
    marginTop: 34,
  },
  ItemContainer: {
    display: 'flex',
    flexDirection: 'column',
    borderTop: `2px solid ${alpha(theme.palette.action.disabledBackground, 0.05)}`,
    minHeight: 125,

    '& .daterow': {
      fontSize: 12,
      marginLeft: 'auto',
      fontWeight: '400',
      fontStyle: 'italic',
    },

    '& .MuiListItemText-primary': {
      fontWeight: 'bold',
      marginBottom: theme.spacing(1),
    },

    '& .MuiTypography-colorTextSecondary': {
      color: theme.palette.text.primary,
    },
  },
  expandContainer: {
    marginLeft: 48,
    width: '90%',
    display: 'flex',
    flexDirection: 'column',
  },
  pad: {
    paddingTop: theme.spacing(1),
  },
  tagContainer: {
    '& p': {
      marginBlock: `${theme.spacing(1)} !important`,
    },
  },
  imageRow: {
    display: 'flex',
    flexDirection: 'row',
    overflow: 'hidden',
    overflowX: 'auto',
  },
  padRow: {
    padding: theme.spacing(2),
  },
  padLeft: {
    paddingLeft: 56,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
    },
  },
}));

export default useStyles;
